// tslint:disable: variable-name
import {
  Directive,
  HostBinding,
  Input,
  ElementRef,
  Renderer2,
  Inject,
  OnInit
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { iconDefs } from '../icon/icon-defs';

const arrowImg = iconDefs.find(iconDef => iconDef.name === 'arrow-right').template;
const externalImg = iconDefs.find(iconDef => iconDef.name === 'external-link').template;

@Directive({
  selector: '[sukaLink]'
})
// tslint:disable-next-line: directive-class-suffix
export class Link implements OnInit {
  @HostBinding('class.link') baseClass = true;

  /**
   * Automatically set to `-1` when link is disabled.
   */
  @HostBinding('attr.tabindex') tabindex: number;

  /**
   * Set target and ref for external links
   */
  @HostBinding('attr.target') target: string;
  @HostBinding('attr.ref') ref: string;

  /**
   * Set to true to disable link.
   */
  @Input()
  @HostBinding('attr.aria-disabled')
  @HostBinding('class.link--disabled')
  set disabled(disabled: boolean) {
    this._disabled = disabled;
    this.tabindex = this.disabled ? -1 : null;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  private _disabled: boolean;

  @HostBinding('class.link--arrow') @Input() arrow = false;

  @Input()
  @HostBinding('class.link--external')
  set external(external: boolean) {
    this._external = external;
    this.target = this.external ? '_blank' : null;
    this.ref = this.external ? 'noopener' : null;
  }

  get external(): boolean {
    return this._external;
  }

  private _external: boolean;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, @Inject(DOCUMENT) private document) { }

  ngOnInit() {
    if (this.arrow || this.external) {
      const child = document.createElement('span');
      child.className = 'link__icon';

      if (this.arrow) {
        child.className += ' link__icon--arrow';
        child.innerHTML = arrowImg;
      }

      if (this.external) {
        child.innerHTML = externalImg;
      }

      this.renderer.appendChild(this.elementRef.nativeElement, child);
    }
  }
}
